import React, { useEffect, useRef, useState } from 'react';

import { boolElemByRole, intervalUpdatingData, set_status, showPaymentStatusBooking, showStatusBooking, showStatusReception, showTypeBooking } from '../../utils/dynamic';

import { fetchData, formatDate } from '../../utils/api';
import { apiUrl } from '../../config'
import BookingEdit from './bookings/BookingEdit'
import BookingView from './bookings/BookingView'
import BookingNew from './bookings/BookingNew'
import { useLanguage } from '../../LanguageContext';
import { useAdminLanguage } from '../../AdminLanguageContext';
import { translateAdmin } from '../../utils/adminTranslations';
import PasswordInput from '../mini/PasswordInput';
import Dashboard from './Dashboard';

const OffMainContent = () => {
	const { language } = useLanguage();
	const { language: adminLanguage } = useAdminLanguage();
	const translate = (text) => translateAdmin(text, adminLanguage);
	const [bookings, setBookings] = useState([])
	const [bookingsMessage, setBookingsMessage] = useState([])

	const [newHandBookingUser, setNewHandBookingUser] = useState(false);
	const [offset, setOffset] = useState(0);
	const [hasMore, setHasMore] = useState(true);
	const [loading, setLoading] = useState(false);
	const LIMIT = 30;

	const [messageBook, setMessageBook] = useState('')
	if (messageBook.length !== 0) {
		setTimeout(() => {
			setMessageBook('')
		}, 3000)
	}

	const [online, setOnline] = useState(false);
	const [isAuthorized, setIsAuthorized] = useState(false);

	const [isEditOpen, setIsEditOpen] = useState(false); // состояние для показа формы редактирования записи
	const [isViewOpen, setIsViewOpen] = useState(false); // состояние для просмотра записи
	const [isNewOpen, setIsNewOpen] = useState(false); // состояние для добавления записи
	const [editData, setEditData] = useState([]); // состояние с данными для редактирования записи
	const [viewData, setViewData] = useState([]); // состояние с данными для просмотра записи

	const [searchQuery, setSearchQuery] = useState(''); // состояние для поиска

	const [sortConfig, setSortConfig] = useState({ key: 'payment_at', direction: 'desc' }); // состояние для сортировки по дате заезда/выезда

	const loadingRef = useRef(false);
	const hasMoreRef = useRef(true);
	const offsetRef = useRef(0);
	const scrollContainerRef = useRef(null);

	const wsRef = useRef(null);
	
	const reconnectTimerRef = useRef(null);
	const shouldReconnectRef = useRef(true);

	useEffect(() => {
		loadingRef.current = loading;
		hasMoreRef.current = hasMore;
		offsetRef.current = offset;
	}, [loading, hasMore, offset]);

	const handleAuthorize = (user) => {
		setNewHandBookingUser(user);
		setIsAuthorized(true);
		setIsNewOpen(true);
	};

	const handleBookingUpdate = (updatedBooking) => {
		setBookings(prev =>
			prev.map(b =>
				b.id === updatedBooking.id ? updatedBooking : b
			)
		);
	};

	// Handle VIEW/EDIT/DELETE click
	const handleVEDNClick = (booking, action) => {
		switch (action) {
			case 'accept':
				setViewData(booking)
				break;
			case 'view':
				setViewData(booking)
				setIsViewOpen(true);
				break;
			case 'edit':
				setEditData(booking)
				setIsEditOpen(true);
				break;
			case 'new':
				setIsNewOpen(true);
				break;
			default:
				break
		}
	};
	const set_statusComp = async (bookingId, method) => {
		const res = await set_status(bookingId, method)
		if (res.status == 0) {
			setBookings(prev => prev.filter(booking => booking.id !== bookingId));
		}
		setMessageBook(res.message)
	}
	// Handle VIEW/EDIT closer
	const handleVENClose = () => {
		setNewHandBookingUser(false);
		setIsAuthorized(false);
		setIsViewOpen(false);
		setIsEditOpen(false);
		setIsNewOpen(false);
	};

	const connectBookingsWS = () => {
		if (!shouldReconnectRef.current) {
			console.log("Reconnect disabled");
			return;
		}

		if (
			wsRef.current &&
			(
				wsRef.current.readyState === WebSocket.OPEN ||
				wsRef.current.readyState === WebSocket.CONNECTING
			)
		) {
			console.log("WS already connected");
			return;
		}

		const ws = new WebSocket(
			`${apiUrl}/ws/sys/off/get-active-bookings`
		);


		wsRef.current = ws;


		ws.onopen = () => {
			console.log("WS connected");

			// первая загрузка
			ws.send(JSON.stringify({
				token: localStorage.getItem("accessToken"),
				action: "initial",
				limit: LIMIT,
				offset: 0,
				search: ""
			}));
		};


		ws.onmessage = (event) => {

			const message = JSON.parse(event.data);

			// первая загрузка
			if (message.type === "initial") {

				const books = message.request;

				if (books.status === 0) {

					const bData = books.data.booking || [];

					const roomsMap = new Map(
						books.data.rooms.map(room => [
							room.id,
							room
						])
					);


					const processedData = bData.map((booking) => {

						const room = roomsMap.get(
							booking.room_id
						);

						return {
							...booking,
							room_type:
								room?.translations
									?.room_type?.[language] || '',
							price:
								room?.price || '',
						};
					});


					setBookings(processedData);

					setOffset(0);

					setHasMore(
						processedData.length === LIMIT
					);
				}
			}

			if (message.type === "search") {

				const books = message.request;

				if (books.status === 0) {

					const bData = books.data.booking || [];

					const roomsMap = new Map(
						books.data.rooms.map(room => [
							room.id,
							room
						])
					);

					const processedData = bData.map((booking) => {

						const room = roomsMap.get(
							booking.room_id
						);

						return {
							...booking,
							room_type:
								room?.translations
									?.room_type?.[language] || '',
							price:
								room?.price || '',
						};
					});

					setBookings(processedData);

					setOffset(0);

					setHasMore(
						processedData.length === LIMIT
					);
				}
			}


			if (message.type === "refresh") {

				const newData = message.request.data.booking || [];

				setBookings(prev => {

					const map = new Map(
						prev.map(item => [item.id, item])
					);


					newData.forEach(item => {

						map.set(
							item.id,
							{
								...map.get(item.id),
								...item
							}
						);

					});


					return Array.from(map.values());

				});
			}



			// догрузка при скролле
			if (message.type === "load_more") {

				const books = message.request;


				if (books.status === 0) {

					const bData = books.data.booking || [];


					const roomsMap = new Map(
						books.data.rooms.map(room => [
							room.id,
							room
						])
					);


					const processedData = bData.map((booking) => {

						const room = roomsMap.get(
							booking.room_id
						);

						return {
							...booking,
							room_type:
								room?.translations
									?.room_type?.[language] || '',
							price:
								room?.price || '',
						};
					});



					setBookings(prev => {

						const newRecords =
							processedData.filter(
								newItem =>
									!prev.some(
										oldItem =>
										oldItem.id === newItem.id
									)
							);

						return [
							...prev,
							...newRecords
						];
					});


					setHasMore(
						processedData.length === LIMIT
					);
				}
			}



			// новая бронь
			if (message.type === "booking_created") {
				setBookings(prev => [
					message.request.data,
					...prev
				]);
			}



			// изменение брони
			if (message.type === "booking_updated") {
				const updated = message.request.data;

				setBookings(prev =>
					prev.map(item =>
						item.id === updated.id
							? {
								...item,
								...updated
							}
							: item
					)
				);
				setViewData(prev =>
					prev?.id === message.request.data.id
						? { ...prev, ...message.request.data }
						: prev
				);
				
			}



			// удаление
			if (message.type === "booking_deleted") {

				setBookings(prev =>
					prev.filter(
						item =>
						item.id !== message.request.data.id
					)
				);
			}
		};



		ws.onclose = () => {
			console.log("WS disconnected");

			if (!shouldReconnectRef.current) {
				console.log("Manual close, no reconnect");
				return;
			}

			if (reconnectTimerRef.current) {
				clearTimeout(reconnectTimerRef.current);
			}

			reconnectTimerRef.current = setTimeout(() => {

				console.log("WS reconnect...");

				connectBookingsWS();

			}, 3000);
		};


		ws.onerror = (error) => {
			console.error("WS error", error);
		};
	};
	
	
	
	const fetchGAB = async (isInitial = false, customLimit = LIMIT, customOffset = 0, query = "") => {
		// Разрешаем выполнение, если это первая загрузка или если мы сейчас НЕ грузим что-то другое
		if (loadingRef.current && !isInitial) return;

		setLoading(true);
		try {
			const token = localStorage.getItem('accessToken');
			// Если customLimit не передан, берем стандартные 30
			const fetchLimit = customLimit || LIMIT;

			const data = await fetchData(
				`${apiUrl}/api/sys/off/get-active-bookings?limit=${fetchLimit}&offset=${customOffset}&c=False&search=${encodeURIComponent(query)}`,
				"GET",
				token
			);

			if (data.request.status === 0) {
				const bData = data.request.data.booking || [];
				const roomsMap = new Map(data.request.data.rooms.map(room => [room.id, room]));

				const processedData = bData.map((booking) => {
					const room = roomsMap.get(booking.room_id);
					return {
						...booking,
						room_type: room?.translations?.room_type?.[language] || '',
						price: room?.price || '',
					};
				});
				if (customOffset === 0) {
					// СЛУЧАЙ 1: Обновление (интервал) или первая загрузка
					// Просто заменяем данные. Если их было 60, и пришло 60 — список останется длинным.
					setBookings(processedData);

					// Если мы запрашивали стандартную пачку (30), проверяем, есть ли смысл листать дальше
					if (fetchLimit === LIMIT) {
						setHasMore(processedData.length === LIMIT);
						setOffset(0); // Сбрасываем офсет, так как мы в начале
					} else {
						// Если мы обновляли, например, 60 записей, и пришло 60 — 
						// мы не меняем hasMore, чтобы не сломать скролл
						if (processedData.length < fetchLimit) {
							setHasMore(false);
						}
					}
				} else {
					// СЛУЧАЙ 2: Дозагрузка (скролл)
					// Добавляем новые данные в хвост
					setBookings(prev => {
						// Берем только те записи, которых еще НЕТ в стейте
						const newRecords = processedData.filter(
							newItem => !prev.some(oldItem => oldItem.id === newItem.id)
						);
						return [...prev, ...newRecords];
					});

					// Если пришло меньше 30, значит база пуста
					setHasMore(processedData.length === LIMIT);
				}
			}
		} catch (error) {
			console.error("Ошибка загрузки:", error);
		} finally {
			setLoading(false);
		}
	};

	useEffect(() => {

		shouldReconnectRef.current = true;
		
		connectBookingsWS();

		return () => {

			console.log("Component unmount");


			shouldReconnectRef.current = false;


			// убираем таймер
			if (reconnectTimerRef.current) {
				clearTimeout(reconnectTimerRef.current);
			}


			// закрываем WS
			if (wsRef.current) {
				wsRef.current.close();
				wsRef.current = null;
			}

		};


	}, []);

	// 4. обработчик скролла
	useEffect(() => {
		const container = scrollContainerRef.current;
		if (!container) return;

		const handleScroll = () => {
			const { scrollTop, scrollHeight, clientHeight } = container;
			const isBottom = scrollTop + clientHeight >= scrollHeight - 100;

			if (isBottom && !loadingRef.current && hasMoreRef.current) {

				const nextOffset = offsetRef.current + LIMIT;

				setOffset(nextOffset);

				offsetRef.current = nextOffset;


				if (wsRef.current?.readyState === WebSocket.OPEN) {

					wsRef.current.send(JSON.stringify({
						action: "load_more",
						limit: LIMIT,
						offset: nextOffset,
						search: ""
					}));

				}
			}
		};

		container.addEventListener('scroll', handleScroll);
		return () => container.removeEventListener('scroll', handleScroll);
	}, []);

	const handleSearchChange = (event) => {

		const value = event.target.value;

		setSearchQuery(value);


		if (wsRef.current?.readyState === WebSocket.OPEN) {

			// сбрасываем пагинацию
			offsetRef.current = 0;
			setOffset(0);


			wsRef.current.send(JSON.stringify({
				action: "search",
				limit: LIMIT,
				offset: 0,
				search: value
			}));
		}
	};

	const handleSort = (key) => {
		let direction = 'asc';

		// Меняем направление, если сортируем по тому же полю
		if (sortConfig.key === key && sortConfig.direction === 'asc') {
			direction = 'desc';
		}
		setSortConfig({ key, direction });
	};

	// Функция для отображения стрелки
	const renderSortArrow = (key) => {
		if (sortConfig.key === key) {
			return sortConfig.direction === 'asc' ? '▲' : '▼';
		}
		return "▼"; // стрелка по умолчанию
	};


	return (
		<>
			<Dashboard type={'offMain'} />

			<section className="system-bookings-table">
				<h2 className='system-bookings-table__title'>{translate('Активные бронирования добавленые в ручную')}</h2>
				<div className='d-flex just-content-sb'>
					{!isAuthorized &&
						<div>
							<label>{translate('Добавить')}</label>
							<PasswordInput onSuccess={handleAuthorize} />
						</div>
					}
					{loading && (
						<div className="loader">
							<div className="circle"></div>
							<div className="circle"></div>
							<div className="circle"></div>
							<div className="circle"></div>
						</div>
					)}
					<div className=''>
						<input
							type="text"
							placeholder={translate('Поиск по тел/имени...')}
							value={searchQuery}
							onChange={handleSearchChange}
							className="search-input search-field"
						/>
					</div>
				</div>
				<h3 className='success-message'>{messageBook}</h3>
				<div className='system-table' ref={scrollContainerRef} style={{ height: '70vh', overflowY: 'auto' }}>
					<table className=''>
						<thead className='system-thead'>
							<tr className='system-tr'>
								<th className='system-th search-field'>№</th>
								<th className='system-th search-field'>{translate('Номер брони')}</th>
								<th className='system-th search-field'>{translate('Номер бланка, чека')}</th>
								<th className='system-th search-field'>{translate('Тип номера')}</th>
								<th className='system-th search-field'>{translate('Имя плательщика')}</th>
								<th className='system-th search-field'>{translate('Тип брони')}</th>
								<th className='system-th'>{translate('Тип оплаты')}</th>
								<th className='system-th search-field'>{translate('Тел.')}</th>
								<th className='system-th system-th__cursor' onClick={() => handleSort('available_from')}>{translate('Дата заезда')} {renderSortArrow('available_from')}</th>
								<th className='system-th system-th__cursor' onClick={() => handleSort('available_to')}>{translate('Дата выезда')} {renderSortArrow('available_to')}</th>
								<th className='system-th'>{translate('Статус')}</th>
								<th className='system-th'>{translate('Общая сумма')}</th>
								{boolElemByRole(['admin', 'booker-admin']) && (
									<th className='system-th'>{translate('Создал')}</th>
								)}
								<th className='system-th'>{translate('Действия')}</th>
							</tr>
						</thead>
						<tbody className='system-tbody'>
							{bookings && bookings.length > 0 ? (
								<React.Fragment>
									{bookings.map((booking, index) => (
										// booking.payment_at === null && booking.report_confirmed_at === null && 'notpaid-status'} ${booking.report_confirmed_at !== null && 'confirmed-check-or-blank'}`
										<tr className={`system-tr ${booking.payment_at !== null
											? "paid-status"
											: booking.report_confirmed_at !== null
												? "confirmed-status"
												: "notpaid-status"
											}`}
											key={index + 1} >
											<td className="system-td">{index + 1}</td>
											<td className="system-td">{booking.book_number}</td>
											<td className="system-td">{booking.blank_number ? booking.blank_number : booking.check_number_card ? booking.check_number_card : booking.check_number_cash ? booking.check_number_cash : ""}</td>
											<td className="system-td">{booking.room_type}</td>
											{booking.cardholdername ? (
												<td className="system-td">{booking.cardholdername}</td>
											) : (
												<td className="system-td">{booking.cardholdername_old}</td>
											)}
											<td className="system-td">{translate(showTypeBooking(booking.type))}</td>
											<td className="system-td">{translate(showPaymentStatusBooking(booking.payment_status))}</td>
											<td className="system-td">{booking.phone_number}</td>
											<td className="system-td">{booking.available_from}</td>
											<td className="system-td">{booking.available_to}</td>
											<td className="system-td">{translate(showStatusBooking(booking.status))}</td>
											<td className="system-td">{booking.amount}</td>
											{boolElemByRole(['admin', 'booker-admin']) && (
												<td className="system-td">{translate(booking.created_by_user_name)}</td>
											)}
											<td className="system-td">
												<button className="system-booking-table-btn system-booking-table-btn-view" onClick={() => handleVEDNClick(booking, 'view')}>{translate('Посмотреть')}</button>
												{/* {booking.status !== 0 && (
                    <button className="system-booking-table-btn system-booking-table-btn-cancel" onClick={() => set_statusComp(booking.id, 'cancelBook')}>Отменить</button>
                    )} */}
											</td>
										</tr>
									))}
								</React.Fragment>
							) : (
								<tr>
									<td className="system-td">{translate(bookingsMessage)}</td>
								</tr>
							)}
						</tbody>
					</table>
				</div>
				<div style={{ padding: '20px', textAlign: 'center' }}>
					{loading && <p>{translate('Загрузка данных...')}</p>}
					{!hasMore && bookings.length > 0 && <p style={{ color: 'gray' }}>{translate('Все данные загружены')}</p>}
				</div>
			</section>
			{isEditOpen && (
				<BookingEdit booking={editData} onClose={handleVENClose} />
			)}
			{isViewOpen && (
				<BookingView booking={viewData} onUpdate={handleBookingUpdate} onClose={handleVENClose} />
			)}
			{isNewOpen && newHandBookingUser && <BookingNew onClose={handleVENClose} newHandBookingUser={newHandBookingUser} />}
		</>
	);
};

export default OffMainContent;